<template>
  <Layout>
    <div class="section  content is-size-7 has-text-white">
      <p class="is-size-5 has-text-primary">Деактивација</p>
      <p>
        Да бисте отказали услугу, пошаљите STOP AAA на 4097 (ВИП, Теленор) и STOPAAA на 4097 (Телеком / МТС).
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Deactivation',
  components: {
    Layout
  },
  methods: {
    check() {
      confirm('Наистина ли искате да се отпишете от услугата?')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/RS/Deactivation.vue